// Add this custom styled dialog component
export const LeftPaneDialog = ({
  children,
  open,
}: {
  children: React.ReactNode;
  open: boolean;
}) => {
  if (!open) return null;

  return (
    <div className="absolute inset-0 z-50">
      <div className="absolute inset-0 bg-black/50" />
      <div className="flex h-full items-center justify-center">
        <div className="relative w-[400px] rounded-lg bg-white p-6">
          {children}
        </div>
      </div>
    </div>
  );
};
